import { createAction, ActionType } from 'typesafe-actions';

export const EnvironmentActions = {
  toggleIsVirtual: createAction('@environment/isVirtual/toggle'),
};
export type EnvironmentAction = ActionType<typeof EnvironmentActions>;
